var map = {
	"./music-instructions.json": 4331,
	"./music-library-intro2024.json": 4332,
	"./music-library-launch2024.json": 4333,
	"./music-progression.json": 4334,
	"./startSourcesAdvanced.json": 4335,
	"./startSourcesSimple.json": 4336,
	"./startSourcesSimple2.json": 4337,
	"./startSourcesTracks.json": 4338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4069;